

const dateConverter = (date, to) => {
    if(to === "us"){
        const parts = date?.split("."); // ["29", "04", "2023"]
        return parts?.reverse()?.join("-"); // "2023.04.29"
    }
    if(to === "us-2"){
        const parts = date?.split("/"); // ["29", "04", "2023"]
        return parts?.reverse()?.join("-"); // "2023.04.29"
    }
    if(to === "tr"){
        const parts = date?.split("-"); // ["29", "04", "2023"]
        return parts?.reverse()?.join("."); // "2023.04.29"
    }
    if(to === "tr-2"){
        const parts = date?.split("-"); // ["29", "04", "2023"]
        return parts?.reverse()?.join("/"); // "2023.04.29"
    }

}

export default dateConverter